var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ul", { attrs: { id: "list-tasks" } }, [
    _c("li", [
      _c("div", { staticClass: "oblea", on: { click: _vm.selectItem } }, [
        _c("div", { attrs: { id: "imagenProductoContainer" } }, [
          _c("img", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.item.EsPromo,
                expression: "item.EsPromo"
              }
            ],
            staticStyle: {
              position: "absolute",
              width: "30px",
              left: "5px",
              top: "5px",
              "z-index": "1",
              display: "block"
            },
            attrs: { src: "/dist/icon_promo.png" }
          }),
          _vm._v(" "),
          _c("img", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.item.showCheck,
                expression: "item.showCheck"
              }
            ],
            attrs: { id: "check", src: "/dist/icon-check.png" }
          }),
          _vm._v(" "),
          _c("div", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.item.ManejaStock,
                expression: "item.ManejaStock"
              }
            ],
            attrs: { id: "semaforo" + _vm.semaforoVal }
          }),
          _vm._v(" "),
          _c("img", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.imagenProducto == null,
                expression: "imagenProducto == null"
              }
            ],
            staticStyle: { width: "40px", height: "40px" },
            attrs: { id: "imagenPlaceholder", src: "/dist/progress-item.gif" }
          }),
          _vm._v(" "),
          _c("img", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.imagenProducto != null,
                expression: "imagenProducto != null"
              }
            ],
            attrs: {
              id: "imagenProducto",
              src: _vm.imagenProducto,
              title: _vm.item.Nombre
            }
          })
        ]),
        _vm._v(" "),
        _c("p", { attrs: { id: "labelProducto" } }, [
          _vm._v(_vm._s(_vm.item.Nombre))
        ]),
        _vm._v(" "),
        _vm.showNombre && _vm.item.PrecioOferta > 0
          ? _c("p", { attrs: { id: "labelPrecioAnt" } }, [
              _vm._v("$" + _vm._s(_vm._f("formatMoney")(_vm.precioOferta)))
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.showNombre
          ? _c("p", { attrs: { id: "labelPrecio" } }, [
              _vm._v("$" + _vm._s(_vm._f("formatMoney")(_vm.precio)))
            ])
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-88dcf5fe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-88dcf5fe","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/realizarPedido/itemRealizarPedido.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-88dcf5fe","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/realizarPedido/itemRealizarPedido.vue
// module chunks = 0